import React, { useEffect, useState } from 'react'
import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import service from '../../api/services';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import { Card } from '@mui/material'
import { ArrowCircleRightOutlined } from '@mui/icons-material';

const Index = () => {
  const params = useParams()
  const Navigate = useNavigate()
  const [allData, setAllData] = useState({})
  const getDetailById = async () => {
    try {
      const res = await service.complaint.getDetailById(params.id);
      setAllData(res?.data?.data)
    } catch (error) {
      console.error('Error fetching user details:', error);
    }
  };

  useEffect(() => {
    console.log("params?.id", params?.id)
    if (params?.id) {
      getDetailById();
    }
  }, [params?.id]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Card className="glassmorphism-card" sx={{ padding: 3, boxShadow: 2 }}>
        <SoftBox sx={{ display: 'flex',gap:2 }}>
          <SoftBox
            variant="outlined"
            color="info"
            style={{ cursor: "pointer" }}
            onClick={() => Navigate(-1)}
          >
            <ArrowCircleRightOutlined
              style={{ transform: "rotate(180deg)", color: "#141414" }}
            />
          </SoftBox>
          <SoftTypography variant="h6" fontWeight="bold" mb={3}>
            Complaints Detail
          </SoftTypography>
        </SoftBox>

        {[
          { label: 'User', value: allData?.name },
          { label: 'Email', value: allData?.email },
          { label: 'Phone', value: allData?.mobileNumber },
          { label: 'Request', value: allData?.message },
          {
            label: 'Created',
            value: allData?.createdAt
              ? moment(allData.createdAt).format('DD/MM/YYYY')
              : '-',
          },
          
        ].map((item, i) => (
          <SoftBox
            key={i}
            display="flex"
            mb={2}
            gap={1.5}
            alignItems="center"
          >
            <SoftTypography
              variant="button" fontWeight="bold" textTransform="capitalize"
            >
              {item.label}
            </SoftTypography>
            <SoftTypography variant="button" fontWeight="bold" textTransform="capitalize">:</SoftTypography>
            <SoftTypography
              variant="button" fontWeight="regular" color="text"
            >
              {item.value}
            </SoftTypography>
          </SoftBox>
        ))}
      </Card>

    </DashboardLayout>
  )
}

export default Index